// extracted by mini-css-extract-plugin
export default {"root":"RentBuyToggle_root__Ov7yJ","option":"RentBuyToggle_option__66XUS","optionActive":"RentBuyToggle_optionActive__XQMm9"};